// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2rBLF","detailsBorder":"styles_detailsBorder__mi3gP"};